import { render, staticRenderFns } from "./ContentList.vue?vue&type=template&id=68e3569a"
import script from "./ContentList.vue?vue&type=script&lang=js"
export * from "./ContentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports